import React from 'react';
import { observer } from 'mobx-react';

const SingleMaterialOverviewRightMenu = observer(() => {
  return <></>;
});

export default SingleMaterialOverviewRightMenu;
